import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { EChartOption, ECharts } from 'echarts'
import { fromEvent } from 'rxjs';
import { debounceTime } from 'rxjs/operators';
import { CommonService } from '../../service/common.service';
import { LegendPieService } from './legend-pie.service'
import { initOpts } from '../../config/initOpts';
import { cloneDeep } from 'lodash';
import { ChartResizeService } from '../../service/chart-resize.service';
import * as color from '../../config/colors';
import * as backgroundColor from '../../config/backgroundColor';
import { ChartDarkModeService } from '../../service/chart-dark-mode.service';

export type legendPosition = 'bottom' | 'right' | 'top' | 'none';

@Component({
  selector: 'bcac-legend-pie',
  templateUrl: './legend-pie.component.html',
  styleUrls: ['./legend-pie.component.scss']
})
export class LegendPieComponent implements OnInit {

  constructor(
    private commonService: CommonService,
    private legendPieService: LegendPieService,
    private chartResizeService: ChartResizeService,
    private chartDarkModeService: ChartDarkModeService
  ) { }

  chartOptions: any = this.legendPieService.getDefaultOptionsOfLegendPieChart();

  _bcacChartTitle: { label: string, show: boolean } = { label: "图表标题", show: true }

  // 标题是否显示
  @Input()
  set bcacChartShowTitle(show: boolean) {
    this._bcacChartTitle.show = show;
  }

  // 标题文本
  @Input()
  set bcacChartTitleText(label: string) {
    this._bcacChartTitle.label = label;
    this._bcacChartFileName = this._bcacChartTitle.label;
  }
  // 图片文件名
  _bcacChartFileName: string = "图表名"
  @Input()
  set bcacChartFileName(fileName: string) {
    this._bcacChartFileName = fileName;
  }
  // 加载等待
  _bcacChartLoading: boolean = false;
  @Input()
  set bcacChartLoading(bcacChartLoading: boolean) {
    this._bcacChartLoading = bcacChartLoading;
  }
  // 设置是否显示toolbox
  @Input()
  set bcacChartShowToolbox(show: boolean) {

    // this.legendPieService.changeToolboxShow(this.chartOptions, show);
    // this.updateOptions()
  }

  // 设置系列名
  @Input()
  set bcacChartSeriesName(bcacChartSeriesName: string) {
    this.legendPieService.changeSeriesName(this.chartOptions, bcacChartSeriesName);
    this.updateOptions();
  }
  // 设置饼图的半径
  @Input()
  set bcacPieChartRadius(bcacPieChartRadius: number | string) {
    this.legendPieService.changeRadius(this.chartOptions, bcacPieChartRadius);
    this.updateOptions();
  }
  // 设置饼图中心位置
  @Input()
  set bcacPieChartCenter(bcacPieChartCenter: Array<string> | Array<number>) {
    this.legendPieService.changeCenter(this.chartOptions, bcacPieChartCenter);
    this.updateOptions();
  }


  isNotSingleData: boolean = false;
  legendDataArr = [];
  bcacData;
  // 更新数据
  @Input()
  set bcacChartData(chartData: any) {
    if (chartData && Array.isArray(chartData)) {
      this.bcacData = chartData;
      let legendDataArr = [];
      chartData.forEach(e => {
        legendDataArr.push(
          {
            label: e.name,
            value: e.name,
            checked: true
          }
        );
      });
      this.legendDataArr = legendDataArr;
      this.legendPieService.changeChartData(this.chartOptions, chartData);
      // if (this.isDarkMode === true) {
      //   this.chartDarkModeService.openPieDarkMode(this.chartOptions, this.isDarkMode);
      // }
    }
    this.updateOptions();
  }

  legendChange(e) {
    this.legendPieService.topLegendChange(e, this.chartInstance);
  }

  @Input()
  set bcacLabelShow(labelShow: boolean) {
    this.legendPieService.changeLabelShowStatus(this.chartOptions, labelShow)
  }

  // 设置labelLine Length 第一段视觉引导线
  @Input()
  set bcacLabelLineLength(bcacLabelLineLength: number) {
    this.legendPieService.changeLineLength(this.chartOptions, bcacLabelLineLength)
  }
  // 设置labelLine length2 第二段视觉引导线长度
  @Input()
  set bcacLabelLineLength2(bcacLabelLineLength2: number) {
    this.legendPieService.changeLineLength2(this.chartOptions, bcacLabelLineLength2)
  }

  // 更改legend显示状态
  @Input()
  set bcacChartShowLegend(showLegend: boolean) {
    // this.legendPieService.changeLegendShowStatus(this.chartOptions, showLegend);
    // this.updateOptions()
  }

  @Output() bcacGetChartInstance: EventEmitter<ECharts> = new EventEmitter();

  initOpts;
  ngOnInit() {
    this.initOpts = initOpts;
    fromEvent(window, 'resize').pipe(debounceTime(200)).subscribe(() => {
      if (this.chartInstance) {
        // this.commonService.setPieChartResize(this.chartInstance, );
        this.chartResizeService.autoPieResizeAdapt(this.chartInstance, this.chartOptions);
      }
    })
  }
  chartInstance: ECharts;
  onOptionInit(ec) {
    this.chartInstance = ec;
    this.bcacGetChartInstance.emit(ec)
  }

  updateOptions() {
    if (this.chartInstance) {
      this.chartInstance.setOption(this.chartOptions, true)
    }
  }

  sourceList: { label: string, value: string }[] = [];
  selectedData: string = "";

  selectedDataChange($event) {
    this.bcacData.forEach(element => {
      if ($event === element.name) {
        this.legendPieService.changeChartData(this.chartOptions, element.data);
        this.updateOptions();
        return;
      }
    });
  }

  customToolBoxRightPosition = "3.5rem";
  @Input()
  set bcacCustomToolBoxRightPosition(value: string) {
    this.customToolBoxRightPosition = value;
  }

  dataSourceSelectData = [];
  @Input()
  set bcacDataSourceList(value: any[]) {
    this.dataSourceSelectData = value;
  }

  @Output()
  bcacDataSourceSelectEmit = new EventEmitter<any>();
  dataSourceChange(e: any) {
    this.bcacDataSourceSelectEmit.emit(e);
  }

  legendPosition = "bottom";
  @Input()
  set bcacLegendPosition(value: string) {
    this.legendPosition = value;
    this.legendPieService.setLegendPosition(this.chartOptions, this.legendPosition)
    this.updateOptions();
  }

  isSmallMode: boolean = false;
  @Input()
  set bcacSmallMode(smallMode: boolean) {
    if (smallMode) {
      this.isSmallMode = true;
      this.changeCardPadding("0rem");
      this.chartResizeService.openSmallMode(this.chartOptions, this.isSmallMode, this.legendPosition);
      // this.chartResizeService.openPieSmallMode(this.chartOptions, this.isSmallMode, this.legendPosition);
      this.updateOptions();
    } else {
      this.isSmallMode = false;
    }
  }

  cardPadding = "1rem";
  changeCardPadding(cardPadding: string) {
    this.cardPadding = cardPadding;
  }

  isDarkMode: boolean | string = false;
  @Input()
  set bcacDarkMode(darkMode: boolean) {
    this.isDarkMode = darkMode;
    this.changeChartTitleColor(darkMode);
    this.changeCardBackgroundColor(darkMode);
    this.chartDarkModeService.openPieDarkMode(this.chartOptions, darkMode);
    this.updateOptions();
  }

  chartTitleColor = '';
  changeChartTitleColor(darkMode: boolean | string) {
    if (!darkMode) {
      this.chartTitleColor = ''
    } else {
      this.chartTitleColor = color.darkModeTextColor;
    }
  }
  cardBgColor = "#fff";
  changeCardBackgroundColor(darkMode: boolean | string) {
    if (typeof (darkMode) === 'string') {
      this.cardBgColor = darkMode;
    } else if (darkMode) {
      this.cardBgColor = backgroundColor.darkModeBGColor;
    }
  }

  @Input()
  set bcacColors(chartColors: string[]) {
    if (Array.isArray(chartColors) && chartColors.every(i => typeof (i) === 'string')) {
      this.commonService.changeChartColors(this.chartOptions, chartColors);
    }
  }
  // echart 图的titleOption
  _chartTitle = ""
  @Input()
  set bcacTitle(chartTitle: string) {
    this._chartTitle = chartTitle;
    this.legendPieService.changeTitleOption(this.chartOptions, chartTitle);
  }

  @Input()
  set bcacLabelType(labelType: 'value' | 'percent') {
    this.legendPieService.changeLabelType(this.chartOptions, labelType);
    this.updateOptions();
  }
  // 改变label对齐方式
  @Input()
  set bcacLabelAlignTo(alignTo: 'none' | 'labelLine' | 'edge') {
    this.legendPieService.changeLabelAlignTo(this.chartOptions, alignTo);
    this.updateOptions();
  }
  // 改变label边距
  @Input()
  set bcacLabelMargin(margin: number | string) {
    this.legendPieService.changeLabelMargin(this.chartOptions, margin);
    this.updateOptions();
  }
  // 改变label出血线大小
  @Input()
  set bcacLabelBleedMargin(bleedMargin: number) {
    this.legendPieService.changeLabelBleedMargin(this.chartOptions, bleedMargin);
  }

  @Input()
  set bcacMinAngle(minAngle: number) {
    this.legendPieService.changeMinAngle(this.chartOptions, minAngle);
  }

}
